<template>
  <div>
    <div container>
      <div grid="row wrap" column="12">
        <div v-html="eyeManage_header_html"></div>
      </div>
      <div grid="row wrap">
        <div class="_mtxs" column="6">
          <app-select
            ref="primaryEyemanageUser"
            :errorMessage="primaryEyemanageUserError"
            :invalid="$v.internalValue.primaryEyemanageUser.$invalid"
            :options="primaryEyemanageUsers"
            :required="false"
            @change="primaryEyemanageUserChanged(true)"
            label='Select Your Primary EyeManage User'
            v-model="$v.internalValue.primaryEyemanageUser.$model"
            valueKey='primaryEyemanageUser'
          />
        </div>
      </div>
      <div grid="row wrap">
        <div class="_mtxs" column="4">
          <app-input
            :disabled="isPrimaryContactUserOther"
            :errorMessage="eyemanageFirstNameError"
            :hidden="isPrimaryContactUserOther"
            :invalid="$v.internalValue.eyemanageFirstName.$invalid"
            :required="false"
            label="First Name:"
            v-model="$v.internalValue.eyemanageFirstName.$model"
            valueKey="eyemanageFirstName"
            @input="emitEyemanageInformation()"
          />
        </div>
        <div class="_mtxs" column="4">
          <app-input
            :disabled="isPrimaryContactUserOther"
            :errorMessage="eyemanageLastNameError"
            :hidden="isPrimaryContactUserOther"
            :invalid="$v.internalValue.eyemanageLastName.$invalid"
            :required="false"
            label="Last Name:"
            v-model="$v.internalValue.eyemanageLastName.$model"
            valueKey="eyemanageLastName"
            @input="emitEyemanageInformation()"
          />
        </div>
        <div class="_mtxs" column="4">
          <app-input
            :disabled="isPrimaryContactUserOther"
            :errorMessage="eyemanageEmailError"
            :hidden="isPrimaryContactUserOther"
            :invalid="$v.internalValue.eyemanageEmail.$invalid"
            :required="false"
            label="Email Address:"
            v-model="$v.internalValue.eyemanageEmail.$model"
            valueKey="eyemanageEmail"
            @input="emitEyemanageInformation()"
          />
        </div>
      </div>
      <div grid="row wrap">
        <div class="_mtxs" column="4">
          <app-input
            :errorMessage="existingBrokerUserIdError"
            :invalid="$v.internalValue.existingBrokerUserId.$invalid"
            :required="false"
            label="Existing Broker User ID:"
            v-model="$v.internalValue.existingBrokerUserId.$model"
            valueKey="existingBrokerUserId"
            @input="emitEyemanageInformation()"
          />
        </div>
      </div>
      <div grid="row wrap">
        <async-button
          column="12" class="btn --sm _mtxs"
          :executing="value.eyeManageInfoValues.dataLoading"
          @clicked="saveEyemanageInformation()"
          :disabled="$v.$invalid || hasTitleSectionError"
        >
          Continue
        </async-button>
      </div>
      <br>
      <div grid="row wrap" v-if="value.userMessage.length !==0 ">
        <ul>
          <li v-for="item in value.userMessage" >
            <p class="lips validation">{{ item}} </p>
          </li>
        </ul>
      </div>
      <div>
        <hr class="_mbxs _mts">
      </div>
    </div>
  </div>
</template>

<script>
  import AppInput from '@atoms/Input'
  import AppSelect from '@atoms/Select'
  import formReady from '@mixins/formReady'
  import { email, maxLength, requiredIf } from 'vuelidate/lib/validators'
  import clientOnboardVerbiage from '@mixins/clientOnboardVerbiage'
  import AsyncButton from '@molecules/AsyncButton'
  import { eventBus } from '@/main'

  export default {
    mixins: [
      formReady,
      clientOnboardVerbiage
    ],
    components: {
      AppInput,
      AppSelect,
      AsyncButton

    },
    props: {
      value: {
        type: Object
      }
    },
    data() {
      return {
        isLastSigner: this.value.eyeManageInfoValues.isLastSigner,
        isPrimaryContactUserOther: false,
        hasTitleSectionError: this.value.eyeManageInfoValues.hasTitleSectionError,
        primaryEyemanageUsers: [],
        internalValue: {
          existingBrokerUserId: this.value.eyeManageInfoValues.existingBrokerUserId || '',
          primaryEyemanageUser: this.value.eyeManageInfoValues.primaryEyemanageUser || '',
          eyemanageFirstName: this.value.eyeManageInfoValues.eyemanageFirstName || '',
          eyemanageLastName: this.value.eyeManageInfoValues.eyemanageLastName || '',
          eyemanageEmail: this.value.eyeManageInfoValues.eyemanageEmail || ''
        }
      }
    },
    validations: {
      internalValue: {
        existingBrokerUserId: {
          maxLength: maxLength(27)
        },
        primaryEyemanageUser: {
          required: requiredIf(function () {
            return this.isLastSigner
          })
        },
        eyemanageFirstName: {
          required: requiredIf(function () {
            return !this.isPrimaryContactUserOther
          }),
          maxLength: maxLength(27)
        },
        eyemanageLastName: {
          required: requiredIf(function () {
            return !this.isPrimaryContactUserOther
          }),
          maxLength: maxLength(27)
        },
        eyemanageEmail: {
          required: requiredIf(function () {
            return !this.isPrimaryContactUserOther
          }),
          email,
          maxLength: maxLength(77)
        }
      }
    },
    computed: {
      existingBrokerUserIdError() {
        if (!this.$v.internalValue.existingBrokerUserId.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      primaryEyemanageUserError() {
        if (!this.$v.internalValue.primaryEyemanageUser.required) {
          return 'required'
        }
        return null
      },
      eyemanageFirstNameError() {
        if (this.$v.internalValue.primaryEyemanageUser.$model === 'Other') {
          if (!this.$v.internalValue.eyemanageFirstName.required) {
            return 'required'
          } else if (!this.$v.internalValue.eyemanageFirstName.maxLength) {
            return 'character limit exceeded'
          }
        }
        return null
      },
      eyemanageLastNameError() {
        if (this.$v.internalValue.primaryEyemanageUser.$model === 'Other') {
          if (!this.$v.internalValue.eyemanageLastName.required) {
            return 'required'
          } else if (!this.$v.internalValue.eyemanageLastName.maxLength) {
            return 'character limit exceeded'
          }
        }
        return null
      },
      eyemanageEmailError() {
        if (this.$v.internalValue.primaryEyemanageUser.$model === 'Other') {
          if (!this.$v.internalValue.eyemanageEmail.required) {
            return 'required'
          } else if (!this.$v.internalValue.eyemanageEmail.maxLength) {
            return 'character limit exceeded'
          } else if (!this.$v.internalValue.eyemanageEmail.email) {
            return 'Not a valid email address'
          }
        }
        return null
      }
    },
    methods: {
      primaryEyemanageUserChanged(changeEvent) {
        this.isPrimaryContactUserOther = this.$v.internalValue.primaryEyemanageUser.$model !== 'Other' || this.$v.internalValue.primaryEyemanageUser.$model === ''
        if (this.$v.internalValue.primaryEyemanageUser.$model === '' || (changeEvent && this.$v.internalValue.primaryEyemanageUser.$model === 'Other')) {
          this.internalValue.eyemanageFirstName = ''
          this.internalValue.eyemanageLastName = ''
          this.internalValue.eyemanageEmail = ''
        } else if (this.$v.internalValue.primaryEyemanageUser.$model === 'GC') {
          this.internalValue.eyemanageFirstName = this.value.groupInfoValues.primaryContactFirstName
          this.internalValue.eyemanageLastName = this.value.groupInfoValues.primaryContactLastName
          this.internalValue.eyemanageEmail = this.value.groupInfoValues.primaryContactEmail
        } else if (this.$v.internalValue.primaryEyemanageUser.$model === 'BC') {
          this.internalValue.eyemanageFirstName = this.value.billingInfoValues.billingContactFirstName
          this.internalValue.eyemanageLastName = this.value.billingInfoValues.billingContactLastName
          this.internalValue.eyemanageEmail = this.value.billingInfoValues.billingContactEmail
        } else if (this.$v.internalValue.primaryEyemanageUser.$model === 'IC') {
          this.internalValue.eyemanageFirstName = this.value.initialMembershipValues.initContactFn
          this.internalValue.eyemanageLastName = this.value.initialMembershipValues.initContactLn
          this.internalValue.eyemanageEmail = this.value.initialMembershipValues.initContactEmail
        } else if (this.$v.internalValue.primaryEyemanageUser.$model === 'OC') {
          this.internalValue.eyemanageFirstName = this.value.ongoingMembershipValues.ongContactFn
          this.internalValue.eyemanageLastName = this.value.ongoingMembershipValues.ongContactLn
          this.internalValue.eyemanageEmail = this.value.ongoingMembershipValues.ongContactEmail
        }
        this.emitEyemanageInformation()
      },
      pushOtherContact() {
        const contactValue = 'Other'
        if (this.primaryEyemanageUsers.length == 0) {
          this.primaryEyemanageUsers.push({ text: '', value: '' })
        }
        this.$delete(this.primaryEyemanageUsers, this.primaryEyemanageUsers.findIndex((f) => f.value === contactValue))
        this.primaryEyemanageUsers.push({ text: 'Other (Please Provide Additional Information)', value: contactValue })
      },
      pushGroupContact() {
        const contactValue = 'GC'
        this.$delete(this.primaryEyemanageUsers, this.primaryEyemanageUsers.findIndex((f) => f.value === contactValue))
        if (this.value.groupInfoValues.primaryContactFirstName.length !== 0 && this.value.groupInfoValues.primaryContactLastName.length !== 0 && this.value.groupInfoValues.primaryContactEmail.length !== 0) {
          const contactText = this.value.groupInfoValues.primaryContactFirstName + ' ' + this.value.groupInfoValues.primaryContactLastName + ' (' + this.value.groupInfoValues.primaryContactEmail + ')'
          this.primaryEyemanageUsers.push({ text: contactText, value: contactValue })
        }
      },
      pushBillingContact() {
        const contactValue = 'BC'
        this.$delete(this.primaryEyemanageUsers, this.primaryEyemanageUsers.findIndex((f) => f.value === contactValue))
        if (this.value.billingInfoValues.billingContactFirstName.length !== 0 && this.value.billingInfoValues.billingContactLastName.length !== 0 && this.value.billingInfoValues.billingContactEmail.length !== 0) {
          const contactText = this.value.billingInfoValues.billingContactFirstName + ' ' + this.value.billingInfoValues.billingContactLastName + ' (' + this.value.billingInfoValues.billingContactEmail + ')'
          this.primaryEyemanageUsers.push({ text: contactText, value: contactValue })
        }
      },
      pushInitialMembershipContact() {
        const contactValue = 'IC'
        this.$delete(this.primaryEyemanageUsers, this.primaryEyemanageUsers.findIndex((f) => f.value === contactValue))
        if (this.value.initialMembershipValues.initContactFn.length !== 0 && this.value.initialMembershipValues.initContactLn.length !== 0 && this.value.initialMembershipValues.initContactEmail.length !== 0) {
          const contactText = this.value.initialMembershipValues.initContactFn + ' ' + this.value.initialMembershipValues.initContactLn + ' (' + this.value.initialMembershipValues.initContactEmail + ')'
          this.primaryEyemanageUsers.push({ text: contactText, value: contactValue })
        }
      },
      pushOngoingMembershipContact() {
        const contactValue = 'OC'
        this.$delete(this.primaryEyemanageUsers, this.primaryEyemanageUsers.findIndex((f) => f.value === contactValue))
        if (!this.value.ongoingMembershipValues.ongoingMatchesInitial && this.value.ongoingMembershipValues.ongContactFn.length !== 0 && this.value.ongoingMembershipValues.ongContactLn.length !== 0 && this.value.ongoingMembershipValues.ongContactEmail.length !== 0) {
          const contactText = this.value.ongoingMembershipValues.ongContactFn + ' ' + this.value.ongoingMembershipValues.ongContactLn + ' (' + this.value.ongoingMembershipValues.ongContactEmail + ')'
          this.primaryEyemanageUsers.push({ text: contactText, value: contactValue })
        }
      },
      isFormValid() {
        this.$v.$touch()
        return !this.$v.$error
      },
      saveEyemanageInformation() {
        if (this.isFormValid()) {
          this.$emit('saveEyemanageInfo', this.internalValue)
        }
      },
      emitEyemanageInformation() {
        this.$emit('eyemanageInfoUpdated', this.internalValue)
      }
    },
    mounted() {
      setTimeout(() => document.getElementById('EyemanageTitle').scrollIntoView(), 100)
      this.$refs.primaryEyemanageUser.$el.children[1].focus()
      this.pushGroupContact()
      this.pushBillingContact()
      this.pushInitialMembershipContact()
      this.pushOngoingMembershipContact()
      this.primaryEyemanageUserChanged()
      this.pushOtherContact()
    },
    created() {
      eventBus.$on('groupTitleSectionHasError', (data) => {
        this.hasTitleSectionError = data
      })
    },
    watch: {
      internalValue: {
        deep: true,
        handler() {
          this.$emit('valueChanged', true)
        }
      }
    }
  }
</script>
